
import {Vue} from 'vue-class-component';
import {useRoute, useRouter} from 'vue-router';
import {RestService} from "../service/rest.service";

export default class HighlightDetailView extends Vue {

  router = useRouter()
  route = useRoute()
  restService = new RestService('highlights')

  item: any = null

  mounted() {
    const id = this.route.params.id as string
    this.restService.get(id)
        .then((data: any) => {
          this.item = data
          this.$nextTick(() => this.initGallery())
        })
        .catch(() => this.router.push('/404'))
  }

  /** 從 YouTube 網址取得影片 ID */
  toVideoId(url: string): string {
    if (!url) return ''
    const watchMatch = url.match(/[?&]v=([^&]+)/)
    if (watchMatch) return watchMatch[1]
    const shortMatch = url.match(/youtu\.be\/([^?]+)/)
    if (shortMatch) return shortMatch[1]
    const embedMatch = url.match(/embed\/([^?]+)/)
    if (embedMatch) return embedMatch[1]
    return ''
  }

  /** YouTube 縮圖網址 */
  toThumbnailUrl(url: string): string {
    const id = this.toVideoId(url)
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : ''
  }

  /** 將 YouTube 網址轉換為嵌入用的 embed 網址 */
  toEmbedUrl(url: string): string {
    if (!url) return ''
    const watchMatch = url.match(/[?&]v=([^&]+)/)
    if (watchMatch) return 'https://www.youtube.com/embed/' + watchMatch[1]
    const shortMatch = url.match(/youtu\.be\/([^?]+)/)
    if (shortMatch) return 'https://www.youtube.com/embed/' + shortMatch[1]
    return url
  }

  initGallery() {
    const modalEl = document.getElementById('hubGalleryModal')
    if (!modalEl) return

    const bootstrap = (window as any).bootstrap
    const modal = new bootstrap.Modal(modalEl, { backdrop: 'static', keyboard: true })

    const mainImg = document.getElementById('hubGalleryMainImg') as HTMLImageElement
    const captionEl = document.getElementById('hubGalleryCaption') as HTMLElement
    const thumbsContainer = document.getElementById('hubGalleryThumbs') as HTMLElement
    const prevBtn = modalEl.querySelector('.hub-gallery-prev') as HTMLElement
    const nextBtn = modalEl.querySelector('.hub-gallery-next') as HTMLElement
    const mainContainer = mainImg.parentElement as HTMLElement

    const MAX_THUMBS = 8
    let currentImagesData: { src: string; alt: string; videoUrl: string | null; title: string }[] = []
    let currentIndex = 0

    function buildImagesDataFromGroup(groupEl: Element) {
      return Array.from(groupEl.querySelectorAll('img')).map((img) => {
        const col = img.closest('.col')
        const title = col ? (col.querySelector('.h5')?.textContent?.trim() || '') : ''
        return {
          src: img.getAttribute('src') || '',
          alt: img.getAttribute('alt') || '',
          videoUrl: img.getAttribute('data-video-url'),
          title
        }
      })
    }

    function showIndex(idx: number) {
      const total = currentImagesData.length
      if (!total) return
      if (idx < 0) idx = total - 1
      else if (idx >= total) idx = 0
      currentIndex = idx
      const data = currentImagesData[currentIndex]

      const existingIframe = mainContainer.querySelector('iframe')
      if (existingIframe) existingIframe.remove()

      if (data.videoUrl) {
        mainImg.classList.add('d-none')
        const iframe = document.createElement('iframe')
        iframe.src = data.videoUrl
        iframe.title = data.alt || 'Video Content'
        iframe.className = 'w-100 h-100 border-0'
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        iframe.allowFullscreen = true
        mainContainer.appendChild(iframe)
      } else {
        mainImg.classList.remove('d-none')
        mainImg.src = data.src
        mainImg.alt = data.alt
      }

      captionEl.textContent = data.title || data.alt || ''
      updateThumbActiveState()
    }

    function renderThumbs() {
      thumbsContainer.innerHTML = ''
      currentImagesData.slice(0, MAX_THUMBS).forEach((imgData, idx) => {
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'border-0 bg-transparent p-0'
        btn.setAttribute('aria-label', `查看第 ${idx + 1} 張內容`)
        const thumbImg = document.createElement('img')
        thumbImg.src = imgData.src
        thumbImg.alt = imgData.alt
        thumbImg.className = 'img-fluid'
        btn.appendChild(thumbImg)
        btn.addEventListener('click', () => showIndex(idx))
        thumbsContainer.appendChild(btn)
      })
    }

    function updateThumbActiveState() {
      thumbsContainer.querySelectorAll('img').forEach((thumb, i) => {
        thumb.classList.toggle('hub-thumb-active', i === currentIndex)
      })
    }

    // 綁定相片/影片群組點擊事件
    document.querySelectorAll('.hub-space-group').forEach((groupEl) => {
      groupEl.querySelectorAll('img').forEach((imgEl, indexInGroup) => {
        (imgEl as HTMLElement).style.cursor = 'pointer'
        imgEl.addEventListener('click', () => {
          currentImagesData = buildImagesDataFromGroup(groupEl)
          renderThumbs()
          showIndex(indexInGroup)
          modal.show()
        })
      })
    })

    prevBtn?.addEventListener('click', () => showIndex(currentIndex - 1))
    nextBtn?.addEventListener('click', () => showIndex(currentIndex + 1))

    // Modal 關閉時清除影片並恢復圖片
    modalEl.addEventListener('hidden.bs.modal', () => {
      const iframe = mainContainer.querySelector('iframe')
      if (iframe) iframe.remove()
      mainImg.classList.remove('d-none')
    })

    // 點擊背景關閉
    modalEl.addEventListener('click', (e) => {
      const dialog = modalEl.querySelector('.modal-dialog')
      if (dialog && !dialog.contains(e.target as Node)) modal.hide()
    })
  }
}
